"use client";

import { useSurvey } from "./survey-provider";

interface BlurredTeaserOverlayProps {
  label: string;
  skeletonCount: number;
  totalCount: number;
  visibleCount: number;
  hiddenCount: number;
  columnCount?: number;
}

export function BlurredTeaserOverlay({
  label,
  skeletonCount,
  totalCount,
  visibleCount,
  hiddenCount,
  columnCount = 6,
}: BlurredTeaserOverlayProps) {
  const { openSurvey } = useSurvey();

  return (
    <div className="relative border-t border-zinc-200">
      <table className="w-full opacity-50 blur-sm">
        <tbody>
          {Array.from({ length: skeletonCount }).map((_, idx) => (
            <tr key={idx} className="border-t border-zinc-200">
              {Array.from({ length: columnCount }).map((_, colIdx) => (
                <td key={colIdx} className="px-4 py-6">
                  <div className="h-4 rounded bg-zinc-100" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 px-4 text-center">
        {hiddenCount > 0 && (
          <p className="text-sm font-medium text-zinc-900">
            +{hiddenCount} more not shown
          </p>
        )}
        <button
          type="button"
          onClick={openSurvey}
          className="inline-flex items-center gap-1.5 rounded bg-zinc-900 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-zinc-800"
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          See all {label}
        </button>
      </div>
    </div>
  );
}
